import {
    ReactChild,
    ReactElement,
    createContext,
    useContext,
    useState,
    SetStateAction,
    Dispatch
} from "react";

export type FooterContextType = {
    footerHeight: number;
    setFooterHeight: Dispatch<SetStateAction<number>>;
};

export type FooterContextProps = {
    children: ReactChild;
};

const defaultFooterHeight = 260;

export const FooterContext = createContext<FooterContextType>({
    footerHeight: defaultFooterHeight,
    setFooterHeight: () => {
        //placeholder function, do nothing
    }
});

export function useFooterContext() {
    return useContext(FooterContext);
}

export const FooterContextProvider = ({
    children
}: FooterContextProps): ReactElement => {
    const [footerHeight, setFooterHeight] = useState(defaultFooterHeight);
    return (
        <FooterContext.Provider
            value={{
                footerHeight,
                setFooterHeight
            }}
        >
            {children}
        </FooterContext.Provider>
    );
};
